<style lang="scss" scoped>
.phone {
	clear: both;
	& ::v-deep .field-label {
		display: none;
	}
	& ::v-deep .field-input {
		padding-top: 0 !important;
		border-color: #dcdfe6;
	}
	& ::v-deep .field-country-flag {
		top: 16px !important;
	}
	& ::v-deep .country-selector-arrow {
		display: none;
	}
	& ::v-deep .select-country-container {
		min-width: 94px;
		max-width: 94px;
	}
}
</style>

<template lang="pug">
    .phone
        vue-phone-number-input(v-model="phone", :default-country-code="original", :preferred-countries="preferred",  @update="change")
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
	name: "Phone",
	components: {
		VuePhoneNumberInput
	},
	props: {
		preferred: {
			type: Array,
			default() {
				return ["GB", "AU"];
			}
		},
		original: {
			type: String,
			default: "GB"
		}
	},
	data: () => ({
		phone: null
	}),
	methods: {
		change(a) {
			this.$emit("input", a.e164);
		}
	}
};
</script>
